<template>
    <!-- <div class="mobi-expire-bg" v-if="userInfo.expire_status">
    <TopUpTip></TopUpTip>
  </div> -->
    <div class="mobi-bg" v-if="vrbase.base">
        <div class="mob-navi">
            <div ref="naviLeft" class="navi-left" @click="onclickClose">
                <a-icon type="left" />
            </div>
            <div class="navi-center">
                <p>{{ vrbase.base && vrbase.base.name }}</p>
            </div>
            <div class="navi-right">
                <span @click="onClickSave"> <a-icon type="save"></a-icon>{{ $t('actionTitles.save') }}</span>
                <span @click="preShow"> <a-icon type="caret-right" />{{ $t('actionTitles.preview') }} </span>
            </div>
        </div>
        <!-- 全景圖片 -->
        <div class="vr-container">
            <edit-pano ref="editPano" />
            <div class="visual" :class="visualActive ? 'active' : ''" v-if="viewVisible"></div>
            <div class="visual-btn" v-if="viewVisible">
                <a-button type="primary" class="set-visual" size="small"
                    @click="onClickSetView">{{ $t('actionTitles.setAngle') }}
                </a-button>
            </div>
        </div>
        <!--場景-->
        <tool-drawer :visible="scenesToolVisible" :bgc="bgc">
            <template slot="body">
                <Scenes @updateServer="updateServerData"></Scenes>
            </template>
        </tool-drawer>
        <!--嵌入-->
        <tool-drawer :visible="injectVisible" :bgc="bgc">
            <template slot="body">
                <Paster></Paster>
            </template>
        </tool-drawer>
        <!--熱點-->
        <tool-drawer :visible="hotspotVisible" :bgc="bgc">
            <template slot="body">
                <Hotspot></Hotspot>
            </template>
        </tool-drawer>
        <!--漫遊-->
        <tool-drawer :visible="autoVisible" :bgc="bgc">
            <template slot="body">
                <Walk></Walk>
            </template>
        </tool-drawer>
        <!-- 遮罩功能(暫停) -->
        <!-- <tool-drawer :visible="shadeVisible" :bgc="bgc">
            <template slot="body">
                <Mask></Mask>
            </template>
        </tool-drawer> -->
        <!--特效-->
        <tool-drawer :visible="specialVisible">
            <template slot="body">
                <Special></Special>
            </template>
        </tool-drawer>
        <!--視覺-->
        <tool-drawer :visible="viewVisible" :bgc="bgc">
            <template slot="body">
                <Angle></Angle>
            </template>
        </tool-drawer>
        <!--設置-->
        <tool-drawer :visible="settingVisible">
            <template slot="body">
                <div class="setting-base">
                    <div class="base-box">
                        <div class="item" @click="handleSetVisible(item.type)" v-for="item in titles" :key="item.type">
                            {{ item.title }}
                        </div>
                    </div>
                </div>
            </template>
        </tool-drawer>
        <!--沙盤-->
        <tool-drawer :visible="sandboxVisible">
            <template slot="body">
                <Sandtable></Sandtable>
            </template>
        </tool-drawer>
        <!--導航-->
        <tool-drawer :visible="naviVisible" :bgc="bgc">
            <template slot="body">
                <Guide></Guide>
            </template>
        </tool-drawer>
        <!-- 沙盤場景 -->
        <div class="sand-box-edit-base-mob" v-if="isSandSceneDraw">
            <ImageDrawer mode="edit" :visible="isSandSceneDraw" right></ImageDrawer>
        </div>
        <!--標尺-->
        <tool-drawer :visible="rulerVisible" :bottom="toolDrawerBottom" :bgc="bgc">
            <template slot="body">
                <Ruler @changeLevel="changeLevel"></Ruler>
            </template>
        </tool-drawer>
        <!--ai主播-->
        <tool-drawer :visible="aiVisible" :bottom="toolDrawerBottom" :bgc="bgc" contentStyle="overflow: visible;">
            <template slot="body">
                <AiPanner></AiPanner>
            </template>
        </tool-drawer>
        <!-- 設置頁面,為了國際化等配置方便，提到這裡 start-->
        <template v-if="Object.keys(VRObject).length > 0">
            <BasicView :visible="basicVisible" @close="basicVisible = false"></BasicView>
            <AdsView :visible="adsVisible" @close="adsVisible = false"></AdsView>
            <MenuView :visible="menuVisible" @close="menuVisible = false"></MenuView>
            <FuncCtl :visible="funcVisible" @close="funcVisible = false"></FuncCtl>
            <PwdSet :visible="pwdVisible" @close="pwdVisible = false"></PwdSet>
            <StartAnimation :visible="StartAnimationVisible" @close="StartAnimationVisible = false"></StartAnimation>
            <mask-view :visible="maskVisible" @close="maskVisible = false"></mask-view>
            <bgm-view :visible="bgmVisible" @close="bgmVisible = false"></bgm-view>
            <speech-explain-view :visible="speechVisible" @close="speechVisible = false"></speech-explain-view>
        </template>

        <!-- 設置頁面,為了國際化等配置方便，提到這裡 end-->
        <!--底部操作-->
        <div class="mobi-bottom">
            <div class="bottom-left">
                <div @click="onClickBtn(sceneData.item, sceneData.index)" :class="currentIndex == 10 ? 'active' : ''"
                    class="navBtn">

                    <img :src="sceneData.item.src" />
                    <h5>{{ $t('edit.editMessage.scenes') }}</h5>
                </div>
            </div>
            <div class="bottom-right">
                <div class="navBtn" v-for="(item, index) in btnTitles" :key="index"
                    :class="{ active: index == currentIndex }" @click="onClickBtn(item, index)">
                    <img :src="item.src" />
                    <h5>{{ item.title }}</h5>
                </div>
            </div>
        </div>

        <!--底部操作-->
        <!-- <div class="mobi-bottom">
            <div
                    class="navBtn"
                    v-for="(item,index) in btnTitles"
                    :key="index"
                    :class="{ active: index == currentIndex && visibleArr[index] == true }"
                    @click="onClickBtn(item, index)"
            >
                <img :src="item.src"/>
                <h5>{{item.title}}</h5>
            </div>
        </div> -->

        <!--退出前確認保存-->
        <a-modal v-model="quitVisible" :width="416" :destroyOnClose="true" :footer="null">
            <Confirm :content="$t('edit.editMessage.backContent')" :cancelTxt="$t('edit.editMessage.backCancelText')"
                :okTxt="$t('edit.editMessage.backOkText')" @onclickOk="quitOkConfirm" @onclickCancel="quitCancelConfirm">
            </Confirm>
        </a-modal>
        <!--預覽確認保存-->
        <!-- <a-modal
            v-model="tourConfirmVisible"
            :width="416"
            :destroyOnClose="true"
            :footer="null"
        >
            <Confirm
            :content="$t('edit.editMessage.content2')"
            :cancelTxt="$t('actionTitles.cancel')"
            :okTxt="$t('edit.editMessage.preConfirm')"
            @onclickOk="tourOkConfirm"
            @onclickCancel="tourConfirmVisible = false"
            ></Confirm>
        </a-modal> -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { v4 as uuidv4 } from "uuid";
import { getWorkDetail } from "@/api/work";
import { baseUrl } from "@/config";
import Special from "./mobComponent/special";
import EditPano from "./component/EditPano";
import ToolDrawer from "./mobComponent/ToolDrawer";
import Scenes from "./mobComponent/scenes";
import Paster from "./mobComponent/paster";
import Hotspot from "./mobComponent/hotspot";
import Walk from "./mobComponent/walk";
import Angle from "./mobComponent/angle";
import Sandtable from "./mobComponent/sandtable";
import Guide from "./mobComponent/guide";
import Setting from "./mobComponent/setting";
import ImageDrawer from "@/components/ImageDrawer";
import BasicView from "./mobComponent/setting/component/BasicView";
import AdsView from "./mobComponent/setting/component/AdsView";
import MenuView from "./mobComponent/setting/component/MenuView";
import FuncCtl from "./mobComponent/setting/component/FuncCtl";
import PwdSet from "./mobComponent/setting/component/PwdSet";
import StartAnimation from "./mobComponent/setting/component/StartAnimation";
import TopUpTip from "@/components/TopUpTip";
import Confirm from "@/components/Confirm";
import MaskView from "./mobComponent/setting/component/MaskView";
import BgmView from "./mobComponent/setting/component/BgmView";
import SpeechExplainView from "./mobComponent/setting/component/SpeechExplainView";
import Ruler from "./mobComponent/ruler";
import AiPanner from "./mobComponent/ai"
// import Mask from "./mobComponent/Mask.vue";

export default {
    components: {
        AiPanner,
        // Mask,
        EditPano,
        ToolDrawer,
        Scenes,
        Paster,
        Hotspot,
        Walk,
        Angle,
        Sandtable,
        Guide,
        Setting,
        ImageDrawer,
        BasicView,
        AdsView,
        MenuView,
        FuncCtl,
        PwdSet,
        StartAnimation,
        TopUpTip,
        Confirm,
        MaskView,
        BgmView,
        SpeechExplainView,
        Special,
        Ruler
    },
    data() {
        return {
            workId: 0,
            visible: false,
            sceneData: {
                index: 10,
                item: { title: this.$t('edit.editMessage.scenes'), type: "scene", src: require('./assets/img/scene.png') },
            },
            btnTitles: [
                // {title: this.$t('edit.editMessage.scenes'),type: "scene",src:require('./assets/img/ph_placeholder-bold.png')},
                { title: this.$t('edit.vrAutoShow'), type: "auto", src: require('./assets/img/wander.png') },
                { title: this.$t('edit.hotpoint'), type: "hotpoint", src: require('./assets/img/hotspot.png') },
                { title: this.$t('edit.inject'), type: "inject", src: require('./assets/img/implant.png') },
                { title: this.$t('edit.vrView'), type: "view", src: require('./assets/img/viewing.png') },
                { title: this.$t('edit.vrNavi'), type: "navi", src: require('./assets/img/Group.png') },
                { title: this.$t('edit.snadbox'), type: "sandbox", src: require('./assets/img/sandbox.png') },
                { title: this.$t("edit.special"), type: "special", src: require('./assets/img/special.png') },
                { title: this.$t("edit.ruler.ruler"), type: "ruler", src: require('./assets/img/iconoir_ruler-add.png') },
                // {title: this.$t("edit.mask"), type: "mask", src: require('@/assets/img/edit_icon_mask.png')},
                { title: this.$t("edit.ai"), type: "ai", src: require('@/assets/img/edit_icon_ai.png') },
                { title: this.$t('edit.setting'), type: "setting", src: require('./assets/img/Setting.png') },
            ],
            titles: [
                { title: this.$t('moduleTitles.basicInfo'), type: "basic" },
                { title: this.$t('edit.editActionTitles.adsSets'), type: "ads" },
                { title: this.$t('edit.editActionTitles.menuSets'), type: "menu" },
                { title: this.$t('edit.editActionTitles.pwdSets'), type: "pwd" },
                { title: this.$t('edit.editActionTitles.senceMaskSets'), type: "mask" },
                { title: this.$t('descriptions.bgm'), type: "bgm" },
                { title: this.$t('edit.editActionTitles.speechExplainSets'), type: "speech" },
                { title: this.$t('edit.editActionTitles.funcSets'), type: "func" },
                { title: this.$t('edit.editActionTitles.startAnimation'), type: "StartAnimation" },
            ],

            currentIndex: -1,
            currentShowType: "",
            quitVisible: false,
            // tourConfirmVisible: false,
            injectVisible: false,
            hotspotVisible: false,
            settingVisible: false,
            sandboxVisible: false,
            specialVisible: false,
            naviVisible: false,
            viewVisible: false,
            autoVisible: false,
            aiVisible: false,
            scenesToolVisible: false,
            isSandSceneDraw: false,
            isGroupMargin: false,
            sandScenes: {},
            VRObject: {},
            currentGroupIdx: 0,
            sceneGroups: [],
            groupMVisible: false,
            scenesVisible: false,
            optionsVisible: false,
            renameVisible: false,
            shareVisible: false,
            basicVisible: false,
            adsVisible: false,
            menuVisible: false,
            pwdVisible: false,
            StartAnimationVisible: false,
            maskVisible: false,
            shadeVisible: false,
            bgmVisible: false,
            speechVisible: false,
            funcVisible: false,
            oldName: "",
            renameObj: {},
            newName: "",
            shareUrl: "",
            vrLoadingKey: "vrLoadingKey",
            visualActive: false,
            rulerVisible: false,
            toolDrawerBottom: '62px',
            bgc: "rgba(51, 51, 51, 0.65)"
        };
    },
    computed: {
        ...mapGetters(["vrbase", "currentScenesId", "userInfo"]),
        show: {
            get: function () {
                return this.isShow;
            },
            set: function () {
            },
        },
    },
    created() {
        this.$store.dispatch("getUserInfo"); //更新用戶的配置
        //if (this.userInfo.expire_status) {
        //    return;
        //}
        this.workId = Number(this.$route.query.id);
        this.$message.loading({
            content: " ",
            key: this.vrLoadingKey,
        });
        getWorkDetail({ id: this.workId }).then((res) => {
            if (res.data) {
                this.VRObject = res.data;
                // if (this.VRObject.base.uid != this.userInfo.id) {
                //     this.$message.error(this.$t("message.noPower"));
                //     return;
                // }
                // 獲取第一個場景id
                this.getFirstSenceFromAll();
                this.$store.dispatch("setVRBase", this.VRObject).then((res) => {
                    initVrshowVue(this);
                    setWork(this.vrbase);
                    setMode("edit");
                    setTourXml(`/api/tourXml?id=${this.workId}`);
                    launchKrpano(null, "/ssr/static/tour/tour.swf");
                    // 處理分享地址
                    this.handleShareUrl();
                    // react native隱藏返回
                    this.hideBackIcon();
                });
                this.sceneGroups = this.vrbase.scene_group.groups;
            }
            this.$message.destroy();
            // this.$message.success({
            //   // content: "準備就緒",
            //   key: this.vrLoadingKey,
            //   duration: 1,
            // });
        });
        //獲取用戶修改權限配置
        this.$store.dispatch("getUserConfig");
    },
    mounted() {
        this.$bus.$on("handleSandboxScene", (data) => {
            this.isSandSceneDraw = true;
            this.sandScenes = data;
        });

        // window.addEventListener("message",function (e) {
        //     const message = e.data
        //     console.log('監聽react-native的消息：',message)
        // })
    },
    methods: {
        // 影藏返回按鈕
        hideBackIcon() {
            if (window.isReactNtiveUse) {
                this.$nextTick(() => {
                    this.$refs.naviLeft && (this.$refs.naviLeft.style.display = "none");
                })
            }
        },
        dragstart(event, data) {
            event.dataTransfer.setData("item", data);
        },
        dragend(event) {
            event.dataTransfer.clearData();
        },
        drop(event) {
            let data = event.dataTransfer.getData("item");
            this.dropData = data;
        },

        handleConfirm() {
            if (this.newName === "") return;
            if (this.renameObj.name) {
                // group更名
                // 循環數組，找到對應的更名對像
                this.sceneGroups.forEach((item) => {
                    if (item.name === this.renameObj.name) item.name = this.newName;
                });
                this.vrbase.scene_group.groups = this.sceneGroups;
            }
            if (this.renameObj.scene_title) {
                //sence更名
                this.vrbase.scenes[this.renameObj.scene_id].scene_title = this.newName;
            }
            this.$store.dispatch("setVRBase", this.vrbase);
            this.renameVisible = false;
            // reset data
            this.newName = "";
            this.oldName = "";
        },
        groupOption(groupIndex, group, type) {
            if ("rename" === type) {
                this.renameObj = group;
                this.oldName = group.name;
                this.renameVisible = true;
            }
            if ("delete" === type) {
                const _this = this;
                this.$confirm({
                    title: _this.$t('edit.editMessage.title'),
                    content: _this.$t('edit.editMessage.content'),
                    okText: _this.$t('edit.editMessage.okText'),
                    okType: "danger",
                    cancelText: _this.$t('edit.editMessage.cancelText'),
                    onOk() {
                        _this.handleDeleteGroup(groupIndex, group);
                    },
                    onCancel() {
                        console.log("取消");
                    },
                });
            }
        },
        handleDeleteGroup(groupIndex, group) {
            if (this.sceneGroups.length == 1) {
                this.$message.error(this.$t('edit.editMessage.deleteGroup'));
                return;
            }
            //過濾刪除的組
            let newList = [];
            this.sceneGroups.forEach((item) => {
                if (item.name !== group.name) newList.push(item);
            });
            if (this.currentGroupIdx === groupIndex) {
                this.currentGroupIdx = newList.length - 1;
            }
            this.sceneGroups = newList;
            this.vrbase.scene_group.groups = this.sceneGroups;
            //被刪除組裡面的場景也要刪除
            const sencesList = group.scenes;
            for (var i = 0; i < sencesList.length; i++) {
                this.$delete(this.vrbase.scenes, sencesList[i]);
            }
            this.$store.dispatch("setVRBase", this.vrbase);
            this.setCurrentSenceToNew(sencesList);
        },
        sceneOption(groupIndex, sceneIdx, type) {
            if ("rename" === type) {
                this.renameObj = this.vrbase.scenes[sceneIdx];
                this.oldName = this.vrbase.scenes[sceneIdx].scene_title;
                this.renameVisible = true;
            }
            if ("delete" === type) {
                const _this = this;
                this.$confirm({
                    title: _this.$t('edit.editMessage.title'),
                    content: _this.$t('edit.editMessage.content'),
                    okText: _this.$t('edit.editMessage.okText'),
                    okType: "danger",
                    cancelText: _this.$t('edit.editMessage.cancelText'),
                    onOk() {
                        _this.handleDeleteScene(sceneIdx);
                    },
                    onCancel() {
                        console.log("取消");
                    },
                });
            }
        },

        handleDeleteScene(sceneIdx) {
            // 至少要保留一個場景
            if (Object.keys(this.vrbase.scenes).length === 1) {
                this.$message.error(this.$t('edit.editMessage.deleteScene'));
                return;
            }
            // 場景對像刪除
            this.$delete(this.vrbase.scenes, sceneIdx);
            // this.sceneGroups = this.vrbase.scenes[sceneIdx];
            // 分組內部的場景刪除，需要遍歷全部分組的全部場景刪除對應id
            for (var i = 0; i < this.sceneGroups.length; i++) {
                let sceneIdList = this.sceneGroups[i].scenes;
                const filArr = sceneIdList.filter((item) => item !== sceneIdx);
                this.sceneGroups[i].scenes = filArr;
                this.$set(this.sceneGroups, i, this.sceneGroups[i]);
            }
            this.vrbase.scene_group.groups = this.sceneGroups;
            this.$store.dispatch("setVRBase", this.vrbase);
            this.setCurrentSenceToNew([sceneIdx]);
        },
        // 當前場景被刪除後需要重新制定場景, 當前分組沒有就到全部場景中去取第一個，否則取分組第一個
        setCurrentSenceToNew(deletedSenceIdList) {
            if (!deletedSenceIdList.includes(this.currentScenesId)) return;
            const currentGroupSences = this.sceneGroups[this.currentGroupIdx].scenes;
            if (currentGroupSences && currentGroupSences.length > 0) {
                this.$store.dispatch("setCurrentScnId", currentGroupSences[0]);
            } else {
                this.getFirstSenceFromAll();
            }
            this.loadScene(this.currentScenesId);
        },

        // 獲取全部場景的第一個場景、
        getFirstSenceFromAll() {
            const scenesArr = Object.keys(this.VRObject.scenes);
            const currId =
                scenesArr.length > 0
                    ? this.VRObject.scenes[scenesArr[0]]["scene_id"]
                    : "";
            this.$store.dispatch("setCurrentScnId", currId);
        },
        getLastSceneSortOrder() {//取當前分組中最後一個場景的sort_order
            const currGroupCenceList = this.sceneGroups[this.currentGroupIdx].scenes;
            let lastSortNum = 0
            if (currGroupCenceList && currGroupCenceList.length > 0) {
                const lastSceneId = currGroupCenceList.slice(-1)[0];
                lastSortNum = this.VRObject.scenes[lastSceneId].sort_order;
            }
            return lastSortNum;
        },
        titleClick(index) {
            this.currentGroupIdx = index;
        },
        onClickAddScene() {
            this.scenesVisible = true;
        },
        // scenesConfirm(list) {
        //   if(!list || list.length === 0) {
        //     this.$message.error("請選擇場景")
        //     return;
        //   }
        //   this.scenesVisible = false;
        //   let newAddScenes = {};
        //   let newAddScenesArr = [];
        //   //獲取選擇的場景id並加入對應分組的scene
        //   for (let i = 0; i < list.length; i++) {
        //     const item = list[i];
        //     // 新增場景到model的scenes下
        //     let newScene = {
        //       scene_id: "scene_" + uuidv4().replace("-", ""),
        //       pid: item.id,
        //       gid: this.sceneGroups[this.currentGroupIdx].id,
        //       sort_order: this.getLastSceneSortOrder() + 1,
        //       scene_title: item.filename,
        //       thumb_path: item.thumb_path,
        //       prefix: item.prefix,
        //       multires: item.multires,
        //       paster: {},
        //       hotspot: {},
        //       angle: {
        //         initview: {
        //           hlookat: 0,
        //           vlookat: 0,
        //         },
        //         fovrange: { min: 0, max: 140, default: 120 },
        //         viewrange: {
        //           hview: { min: -180, max: 180 },
        //           vview: { min: -90, max: 90 },
        //         },
        //       },
        //     };
        //     newAddScenes[newScene.scene_id] = newScene; //提供給沙盤使用
        //     newAddScenesArr.push(newScene);
        //     this.$set(this.vrbase.scenes, newScene.scene_id, newScene);
        //     this.sceneGroups[this.currentGroupIdx].scenes.push(newScene.scene_id);
        //   }
        //   addScenes(newAddScenesArr);
        //   this.loadScene(this.currentScenesId);
        //   this.updateStore(this.vrbase);
        // },
        addGroup() {
            this.groupMVisible = true;
        },
        loadScene(sceneId) {
            this.$store.dispatch("loadScene", sceneId);
        },
        onClickBtn(item, index) {
            console.log(this.currentShowType);
            if (this.currentShowType === item.type) {
                const changeStatus = {
                    inject: () => (this.injectVisible = !this.injectVisible),
                    hotpoint: () => (this.hotspotVisible = !this.hotspotVisible),
                    sandbox: () => (this.sandboxVisible = !this.sandboxVisible),
                    navi: () => (this.naviVisible = !this.naviVisible),
                    view: () => (this.viewVisible = !this.viewVisible),
                    auto: () => (this.autoVisible = !this.autoVisible),
                    setting: () => (this.settingVisible = !this.settingVisible),
                    scene: () => (this.scenesToolVisible = !this.scenesToolVisible),
                    special: () => (this.specialVisible = !this.specialVisible),
                    ruler: () => (this.rulerVisible = !this.rulerVisible),
                    mask: () => (this.shadeVisible = !this.shadeVisible),
                    ai: () => (this.aiVisible = !this.aiVisible)
                };
                changeStatus[item.type]();
                this.toggleKrContent();
                return;
            }
            this.currentIndex = index;
            this.currentShowType = item.type;
            const type = item.type;
            const handlerObj = {
                inject: type === "inject",
                hotpoint: type === "hotpoint",
                sandbox: type === "sandbox",
                navi: type === "navi",
                view: type === "view",
                auto: type === "auto",
                setting: type === "setting",
                scene: type === "scene",
                special: type === "special",
                ruler: type === "ruler",
                mask: type === "mask",
                ai: type === "ai"
            };

            this.injectVisible = handlerObj["inject"];
            this.hotspotVisible = handlerObj["hotpoint"];
            this.settingVisible = handlerObj["setting"];
            this.sandboxVisible = handlerObj["sandbox"];
            this.naviVisible = handlerObj["navi"];
            this.viewVisible = handlerObj["view"];
            this.autoVisible = handlerObj["auto"];
            this.scenesToolVisible = handlerObj["scene"];
            this.specialVisible = handlerObj["special"];
            this.isSandSceneDraw = handlerObj["sandbox"];
            this.rulerVisible = handlerObj["ruler"];
            this.shadeVisible = handlerObj["mask"];
            this.aiVisible = handlerObj["ai"];
            this.toggleKrContent();
        },
        toggleKrContent() {
            toggleEditPasterVisible(this.injectVisible);
            toggleEditHotspotVisible(this.hotspotVisible);
            toggleEditGuidePointVisible(this.naviVisible);
            toggleEditSceneHotspotVisible(this.autoVisible);
            toggleSunEpecialHotspotVisible(this.specialVisible);
            toggleEditRulerVisible(this.rulerVisible);
            // this.shadeVisible ? this.handleShade(this.currentScenesId) : this.hiddenShade(this.shadeVisible);
        },
        // hiddenShade(value){
        //     const skyMaskId = "shade_sky_mask_id";
        //     const groundMaskId = "shade_ground_mask_id";
        //     let key = 'visible'; 
        //     setShadeScale(skyMaskId, key, value);
        //     setShadeScale(groundMaskId, key, value);
        // },
        // handleShade(sceneId) {
        //   const skyMaskId = "shade_sky_mask_id";
        //   const groundMaskId = "shade_ground_mask_id";
        //   let date = new Date();
        //   let currentDateParam = "?v="+date.getFullYear()+""+(date.getMonth()+1)+""+date.getDate();
        //   removeAllShade(skyMaskId, groundMaskId);
        //   //global
        //   const mask_global_settings = this.vrbase.ads.fix_logo;
        //   //sceene
        //   const mask_scene_settings = this.vrbase.scenes[sceneId].sky_land_shade;
        //   if (mask_scene_settings && mask_scene_settings.land) {
        //     addSceneShade(groundMaskId, mask_scene_settings.land+currentDateParam, 90)
        //   } else if (mask_global_settings && mask_global_settings.land) {
        //     addSceneShade(groundMaskId, mask_global_settings.land+currentDateParam, 90,mask_global_settings.land_scale,mask_global_settings.land_angle)
        //   }
        //   if (mask_scene_settings && mask_scene_settings.sky) {
        //      addSceneShade(skyMaskId, mask_scene_settings.sky+currentDateParam, -90)
        //   } else if (mask_global_settings && mask_global_settings.sky) {
        //      addSceneShade(skyMaskId, mask_global_settings.sky+currentDateParam, -90,mask_global_settings.sky_scale, mask_global_settings.sky_angle)
        //   }
        // },
        handleGroupMargin(value) {
            this.isGroupMargin = value;
        },
        handleChange() {
        },
        onChange() {
        },
        handleShareUrl() {
            let routeUrl = this.$router.resolve({
                name: "Tour", //這個name就是你剛剛配置在router裡邊的name
                params: {
                    id: this.vrbase.base.uuid,
                },
            });
            this.shareUrl = routeUrl.href;
        },
        async preShow() {
            // this.tourConfirmVisible = true;
            await this.$store.dispatch("saveVRBase", { vrbase: this.vrbase, showLoading: true });
            this.handleShareUrl();
            if (window.isReactNtiveUse) {//react native
                const data = {
                    cmd: "preView",
                    data: this.shareUrl
                }
                window.ReactNativeWebView.postMessage(JSON.stringify(data));
            } else {//非react native
                let a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.id = "toTour";
                a.text = "toTour";
                a.href = this.shareUrl;
                document.getElementById("toTour").click();
                document.body.removeChild(a);
            }
        },
        share() {
            this.shareVisible = true;
        },
        // 更新store數據
        updateStore(vrbase) {
            this.$store.dispatch("setVRBase", vrbase);
        },
        //熱點更新回調
        updateHotspot(data) {
            if (
                this.vrbase.scenes[data.scene_id] &&
                this.vrbase.scenes[data.scene_id].hotspot[data.hotspot_id]
            ) {
                const item = this.vrbase.scenes[data.scene_id].hotspot[data.hotspot_id];
                item.ath = data.ath;
                item.atv = data.atv;

                const vrbase = this.vrbase;
                vrbase.scenes[data.scene_id].hotspot[data.hotspot_id].ath = data.ath;
                vrbase.scenes[data.scene_id].hotspot[data.hotspot_id].atv = data.atv;

                this.updateStore(vrbase);
            }

            this.$bus.$emit("updateHotspot", data);
        },
        updatePaster(data) {
            if (
                this.vrbase.scenes[data.scene_id] &&
                this.vrbase.scenes[data.scene_id].paster[data.paster_id]
            ) {
                const paster = this.vrbase.scenes[data.scene_id].paster[data.paster_id];
                paster.ath = data.ath;
                paster.atv = data.atv;
                this.updateStore(this.vrbase);
            }
            this.$bus.$emit("updatePaster", data);
        },
        clickPaster(sceneId, pasterId) {
            this.$bus.$emit("clickPaster", pasterId);
        },
        //太陽光坐標更新
        updateSunEffectSetting(sceneId, ath, atv) {
            const data = { ath, atv }
            this.$bus.$emit("updateSunEffectSettingFunc", data);
        },
        updateGuidePoint(data) {
            let vrbase = this.vrbase;
            let point = vrbase.guide[0].points.find(
                (p) => p.point_id == data.point_id
            );
            point.ath = data.ath;
            point.atv = data.atv;
            point.fov = data.fov;
            this.updateStore(vrbase);
        },
        hlookatChange(sceneId, hlookat) {
            if (this.currentHlookat != hlookat) {
                this.$store.dispatch("setCurrentHlookat", hlookat);
            }
        },
        sceneChange(currentSenceId) {
            this.$store.dispatch("setCurrentScnId", currentSenceId);
        },
        toggleBtns(visible) {
        },
        toggleMusicVisible(visible) {
        },
        toggleSpeechVisible(visible) {
        },
        updateServerData() {
            this.$store.dispatch("saveVRBase", { vrbase: this.vrbase, showLoading: true }).then(res => {
                if (res && Object.keys(res.data).length > 0) {
                    this.vrbase.scenes = res.data.scenes
                    this.VRObject.scenes = res.data.scenes
                }
            });
        },
        onclickClose() {
            this.quitVisible = true;
        },
        quitOkConfirm() {
            this.$store.dispatch("saveVRBase", { vrbase: this.vrbase, showLoading: true }).then(res => {
                this.$router.go(-1);
            });
            this.quitVisible = false
        },
        quitCancelConfirm() {
            this.$router.go(-1);
            this.quitVisible = false
        },
        onClickSave() {
            console.log("onClickSave=", this.vrbase);
            // 刪除場景為空的分組
            for (var i = 0; i < this.sceneGroups.length; i++) {
                let sceneIdList = this.sceneGroups[i].scenes;
                if (sceneIdList.length === 0) {
                    this.$delete(this.sceneGroups, i);
                }
            }
            this.$store.dispatch("saveVRBase", { vrbase: this.vrbase, showLoading: true });
        },
        onClickSetView() {
            const vrbase = this.vrbase;
            const currView = getSceneViewAt();
            vrbase.scenes[this.currentScenesId].angle.initview = this.$deepClone(currView);
            this.$store.dispatch("saveVRBase", { vrbase, showLoading: true });
            // this.updateStore(vrbase);
            this.visualActive = true;
            setTimeout(() => {
                this.visualActive = false;
            }, 500);
        },
        handleSetVisible(type) {
            const handlerObj = {
                basic: type === "basic",
                ads: type === "ads",
                menu: type === "menu",
                pwd: type === "pwd",
                mask: type === "mask",
                bgm: type === "bgm",
                speech: type === "speech",
                func: type === "func",
                StartAnimation: type === "StartAnimation",
            };
            this.basicVisible = handlerObj["basic"];
            this.adsVisible = handlerObj["ads"];
            this.menuVisible = handlerObj["menu"];
            this.pwdVisible = handlerObj["pwd"];
            this.StartAnimationVisible = handlerObj["StartAnimation"]
            this.maskVisible = handlerObj["mask"];
            this.bgmVisible = handlerObj["bgm"];
            this.speechVisible = handlerObj["speech"];
            this.funcVisible = handlerObj["func"];
        },
        //改變到二級就隱藏底部選單
        changeLevel(type) {
            if (type == 'next') {
                this.mobiBottomVisible = false
                this.toolDrawerBottom = '62px'
            }
            if (type == 'prev') {
                this.mobiBottomVisible = true
                this.toolDrawerBottom = '62px'
            }
        },
    },
};
</script>

<style lang="less" scoped>
.mobi-expire-bg {
    min-height: 300px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mobi-bg {
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(64, 64, 64, 1);
    width: 100%;
    height: 100%;
    user-select: none;

    button.ant-btn-primary,
    .navBtn button.ant-btn-primary {
        background-color: #404040;
        border-color: #2e2e2e;
    }

    button.set-visual.ant-btn-primary {
        background-color: rgba(64, 64, 64, 0.8);
        border-color: rgba(64, 64, 64, 0.8);
    }

    .active button.ant-btn-primary {
        background-color: #015c61;
        border-color: #015c61;
    }
}

.sand-box-edit-base-mob {
    position: absolute;
    top: 45px;
    left: 10px;
    padding: 0;
    /*10px;*/
    background-color: rgba(255, 255, 255, 0.4);
    -webkit-transform-origin: top right;
    -ms-transform-origin: top right;
    transform-origin: top right;
    z-index: 998;
    // width: 220px;
    // max-width: 600px;
    // max-height: 600px;
}

.mob-navi {
    color: white;
    background-color: rgba(0, 0, 0, 0.35);
    font-size: 14px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    position: fixed;
    z-index: 997;
    top: 0;
    right: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    overflow: hidden;

    .navi-left {
        width: 30px;
        text-align: left;
        flex-shrink: 0;
    }

    .navi-center {
        flex: 1;
        width: 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        p {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-bottom: 0;
            font-size: 14px;
            /*margin: auto;*/
        }
    }

    .navi-right {
        text-align: right;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        font-size: 14px;

        span {
            margin-right: 5px;
            background: rgba(0, 0, 0, 0.08);
            border: 1px solid rgba(0, 0, 0, 0.08);
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 8px;
            border-radius: 4px;

            &:last-child {
                margin-right: 0;
            }

            i {
                margin-right: 4px;
            }
        }
    }
}

.vr-container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    .visual {
        width: 70%;
        height: 30%;
        position: absolute;
        top: 40%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        overflow: visible;
        opacity: 1;
        cursor: default;
        pointer-events: none;
        background: url(./assets/img/view_frame.png);
        background-size: 100% 100%;
        background-repeat: no-repeat no-repeat;

        &.active {
            background: url(./assets/img/view_frame_color.png);
            background-size: 100% 100%;
            background-repeat: no-repeat no-repeat;
        }
    }

    .visual-btn {
        position: absolute;
        top: 40%;
        left: 50%;
        text-align: center;
        margin-right: -50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        width: 200px;
    }
}

.mobi-bottom {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    height: 62px;
    background-color: rgba(38, 38, 38, 1);
    font-size: 14px;
    /*display: flex;*/
    /*align-items: center;*/
    padding-left: 54px;

    .bottom-left {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        // width: 97px;
        z-index: 100;
        // padding: 9px 0 0 15px;
        box-shadow: 5px 0 4px 0 rgba(0, 0, 0, 0.1);
    }

    .bottom-right {
        // padding-top: 9px;
        width: 100%;
        overflow-x: scroll;
        white-space: nowrap;
        height: 62px;
    }

    .navBtn {
        height: 55px;
        display: inline-block;
        width: 56px;
        text-align: center;
        // height: 100%;
        padding-top: 12px;
        margin-right: 2px;
        opacity: .6;
        // overflow:hidden;
        // button.ant-btn-primary[data-v-0eb983a7] {
        //     background-color: #404040;
        //     border-color: #2e2e2e;
        // }

        // .active button.ant-btn-primary {
        //     background-color: #1890ff;
        //     border-color: #1890ff;
        // }
        &:last-child {
            margin-right: 0;
        }

        &.active {
            opacity: 1;
        }

        img {
            width: 24px;
            height: 24px;
        }

        h5 {
            color: #f2f2f2;
        }
    }
}

.mobi-bottom::-webkit-scrollbar {
    display: none;
}

.setting-base {
    height: 49px;
    overflow: hidden;
    background-color: #333;
    /*display: flex;
        align-items: center;
        justify-content: space-between;*/

    .base-box {
        width: 100%;
        height: 54px;
        padding: 10px;
        overflow-x: scroll;
        white-space: nowrap;

        .item {
            /*width: 18%;*/
            display: inline-block;
            padding: 0 10px;
            margin-right: 15px;
            height: 28px;
            line-height: 29px;
            text-align: center;
            background-color: #5a5a5a;
            // color: rgba(45, 45, 45, 1);
            color: #ffffff;
            font-size: 12px;
            border-radius: 13px;

            &:last-child {
                margin-right: 0;
            }
        }
    }

}

// /*底部操作樣式*/
// .mobi-bottom {
//     position: fixed;
//     bottom: 0;
//     right: 0;
//     left: 0;
//     height: 62px;
//     background-color: #000000;
//     font-size: 14px;
//     overflow-x: scroll;
//     white-space: nowrap;

//     &::-webkit-scrollbar {
//         display: none;
//     }

//     .navBtn {
//         width: 56px;
//         text-align: center;
//         display: inline-block;
//         height: 100%;
//         padding-top: 12px;
//         margin-right: 2px;

//         &:last-child {
//             margin-right: 0;
//         }

//         &.active {
//             img {
//                 opacity: 1;
//             }

//             h5 {
//                 color: #e6e6e6;
//             }
//         }

//         img {
//             opacity: .6;
//             width: 24px;
//             height: 24px;
//         }

//         h5 {
//             color: #727272;
//         }
//     }
// }
</style>


<!--vr編輯.vr-bg的全局樣式-->
<style lang="less">
.selection {

    /*padding: 5px 10px;*/
    .selection-top {
        /*padding-bottom: 10px;*/
        padding: 10px 10px 10px 10px;
        display: flex;
        border-bottom: 1px solid rgba(0, 0, 0, .1);
        box-shadow: 0 1px 1px 0 rgba(255, 255, 255, .05);
        align-items: center;
        justify-content: space-between;
        background-color: #333333;

        .selection-arrow {
            width: 70px;
            height: 25px;
            line-height: 25px;
        }

        .click-btn {
            height: 25px;
            line-height: 26px;
            padding: 0 10px;
            border-radius: 2px;
            color: #ffffff;
            background-color: #015c61;
        }
    }

    .selection-bottom {
        /*border-top: 1px solid rgba(255,255,255,.04);*/
        background-color: #333333;
        padding: 10px 10px 10px 10px;
        width: 100%;
        overflow-y: auto;
    }
}

/deep/.ant-modal-footer .ant-btn-primary {
    background-color: #015c61 !important;
    border-color: #015c61 !important;
}
</style>
